// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".filter-accordion__header[data-v-271ad629]{width:100%;display:flex;align-items:center;justify-content:space-between}", ""]);
// Exports
module.exports = exports;
